module.exports = __webpack_public_path__ + "img/BrandImg1.4e321fa1.png";